<template>
  <v-container class="ma-0 pa-0" style="height: 100%">
    <v-form ref="refSettingsObserver" class="ma-0 pa-2" align-items="center" flat>
      <v-row class="ma-0 pb-6">
        <v-alert type="info" class="ma-0 pa-2" :class="isOnMobile ? '' : 'mr-8'" dense dismissible>
          <v-row class="ma-0 pa-0">
            <span class="subtitle-2" style="text-align: justify">Тук може да добавите „Наблюдател“ (например счетоводител). Потребителят с права на наблюдател ще има достъп до данните от устройствата Ви, но няма да може да редактира или променя абонаментните им планове.</span>
          </v-row>
          <v-row class="ma-0 pa-0">
            <span class="subtitle-2" style="text-align: justify">Ако Вашият счетоводител все още няма акаунт, може да се регистрира напълно безплатно. След това е необходимо да го добавите като "Наблюдател".</span>
          </v-row>
        </v-alert>
      </v-row>

      <v-row class="ma-2 pa-0 pb-3">
        <span class="ma-0 pa-0">{{ "Наблюдаващ профил: " + (observerData.oCuserCompanyName ? observerData.oCuserCompanyName : "Няма") }}</span>
      </v-row>
      <v-row class="ma-2 pa-0 pb-2">
        <v-text-field v-model="observerData.observerEmail" class="ma-0 pa-0" label="Електронна поща на наблюдателя" :rules="global_rules.email"></v-text-field>
      </v-row>
      <v-row class="ma-2 pa-0 pb-2">
        <v-text-field v-model="observerData.observerEik" class="ma-0 pa-0" label="ЕИК на наблюдателя" :rules="global_rules.validEIK"></v-text-field>
      </v-row>
      <v-row class="ma-0 pa-0">
        <t-button :btnDisabled="isSaveDisabled" class="ma-2 pa-2" style="min-width: 120px" :btnIcon="'mdi-checkbox-marked-circle-outline'" :btnText="observerData.oCuserCompanyName ? 'Запази' : 'Запази'" @click.native="addObserver(true)" />
        <t-button :btnDisabled="isSaveDisabled || !observerData.oCuserCompanyName" style="min-width: 120px" class="ma-2 pa-2" :btnIcon="'mdi-minus-circle'" :btnText="'Премахни'" @click.native="addObserver(false)" />
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
export default {
  data() {
    return {
      isSaveDisabled: false,
      user: null,
      observerData: {}
    };
  },
  methods: {
    setTitleAndData(meta, error) {
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.user = DataManager.getData(meta.datatype);
        if (this.user.observedBy) {
          this.observerData = {
            observerEik: this.user.observedBy ? this.user.observedBy.eik : "",
            observerEmail: this.user.observedBy ? this.user.observedBy.email : "",
            oCuserCompanyName: this.user.observedBy ? this.user.observedBy.oCuserCompanyName : "",
            onOff: true
          };
        }
      }
    },
    addObserver(enable) {
      if (enable) {
        if (!this.$refs.refSettingsObserver.validate()) {
          this.dialogLoader.showError("Невалидни данни за наблюдател!", { location: "center" });
          return;
        }
      }
      this.isSaveDisabled = true;
      this.observerData.onOff = enable;
      delete this.observerData.oCuserCompanyName;
      DataManager.updateUserObserver(this.observerData, error => {
        if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          this.dialogLoader.showInfo("Успешно " + (enable ? "добавяне" : "премахване") + " на наблюдател.");
          this.$refs.refSettingsObserver.reset();
          DataManager.loadData(
            DataManager.DataType.user,
            err => {
              if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                this.user = DataManager.getData(DataManager.DataType.user);
                this.observerData = {
                  observerEik: this.user.observedBy ? this.user.observedBy.eik : "",
                  observerEmail: this.user.observedBy ? this.user.observedBy.email : "",
                  oCuserCompanyName: this.user.observedBy ? this.user.observedBy.oCuserCompanyName : "",
                  onOff: true
                };
              }
            },
            true
          );
        } else {
          this.dialogLoader.showError(error.Message, { location: "center" });
        }
        setTimeout(() => {
          this.isSaveDisabled = false;
        }, 3000);
      });
    }
  }
};
</script>

<style>
</style>